import { render, staticRenderFns } from "./Traitement.vue?vue&type=template&id=0521c326&"
import script from "./Traitement.vue?vue&type=script&lang=js&"
export * from "./Traitement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0521c326')) {
      api.createRecord('0521c326', component.options)
    } else {
      api.reload('0521c326', component.options)
    }
    module.hot.accept("./Traitement.vue?vue&type=template&id=0521c326&", function () {
      api.rerender('0521c326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pain008/Traitement.vue"
export default component.exports